import _jsx from "@babel/runtime/helpers/jsx";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _dec, _dec2, _dec3, _class, _class2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import cx from 'classnames';
import _ from 'lodash';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import NoSsr from '@mui/material/NoSsr';
import withWidth, { isWidthDown } from 'muiCompat/withWidth';
import VideoPlayer from '../../../components/VideoPlayer/VideoPlayer';
import { getStreamChatUrl, isIOS } from '../../../helpers';
import isLoggedIn from '../../../helpers/checkAuth';
import LivestreamBadge from '../LivestreamBadge/LivestreamBadge';
import AppContext from '../../../context';
import s from './CourseLivestream.scss';
import messages from './courseLivestreamMessages';
import intlPropTypes from '../../../constants/intlPropTypes';
var CourseLivestream = (_dec = withWidth(), _dec2 = withStyles(s), _dec3 = connect(function (state) {
  return {
    auth: state.auth,
    course: state.courseDetails.course,
    isLiveStreamChatShown: state.courseDetails.isLiveStreamChatShown,
    lang: state.intl.locale
  };
}), injectIntl(_class = _dec(_class = _dec2(_class = _dec3(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(CourseLivestream, _React$Component);
  var _super = _createSuper(CourseLivestream);
  function CourseLivestream(props) {
    var _this;
    _classCallCheck(this, CourseLivestream);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onVideoPlayerUnmount", function () {
      if (_this.player) {
        try {
          _this.removeVideoPlayerEvents();
        } catch (error) {
          console.error(error);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onVideoPlayerReady", function (player) {
      player.on('play', _this.startPlaying);
      player.on('pause', _this.pausePlaying);
      player.on('waiting', _this.pausePlaying);
      player.on('ended', _this.pausePlaying);
    });
    _defineProperty(_assertThisInitialized(_this), "logVideoProgress", function () {
      var _this$props = _this.props,
        course = _this$props.course,
        auth = _this$props.auth;
      var watchingSessionStart = _this.state.watchingSessionStart;
      if (!isLoggedIn(auth)) {
        return false;
      }
      var data = {
        playedTime: Math.round(_this.totalTime + _this.time),
        startedPlaying: watchingSessionStart
      };
      return _this.context.fetch("/api/courses/".concat(course._id, "/log-live-stream"), {
        method: 'POST',
        body: JSON.stringify(data)
      })["catch"](console.error);
    });
    _defineProperty(_assertThisInitialized(_this), "removeVideoPlayerEvents", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
        player = _assertThisInitialize.player;
      player.off('pause');
      player.off('waiting');
      player.off('play');
      player.off('progress');
      player.off('ended');
    });
    _defineProperty(_assertThisInitialized(_this), "startPlaying", function () {
      _this.timeStartedPlaying = new Date();
      _this.timer = setInterval(function () {
        _this.time = (new Date().getTime() - _this.timeStartedPlaying.getTime()) / 1000;
        _this.logVideoProgressDebounced();
      }, 1000);
    });
    _defineProperty(_assertThisInitialized(_this), "pausePlaying", function () {
      if (_this.timer) {
        clearInterval(_this.timer);
      }
      var timeStartedPlaying = _this.timeStartedPlaying || new Date();
      _this.totalTime += (new Date().getTime() - timeStartedPlaying.getTime()) / 1000;
      _this.time = 0;
    });
    _this.state = {
      watchingSessionStart: new Date(),
      chatUrl: ''
    };
    _this.timer = null;
    _this.totalTime = 0;
    _this.time = 0;
    _this.timeStartedPlaying = 0;
    _this.logVideoProgressDebounced = _.throttle(_this.logVideoProgress, 5000);
    return _this;
  }
  _createClass(CourseLivestream, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props2, videoId, videoService, videoAppId, course, chatUrl;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = this.props, videoId = _this$props2.videoId, videoService = _this$props2.videoService, videoAppId = _this$props2.videoAppId, course = _this$props2.course;
              _context.next = 3;
              return getStreamChatUrl(course.youtubeVideoUrl, {
                videoId: videoId,
                videoService: videoService,
                videoAppId: videoAppId
              }, this.context);
            case 3:
              chatUrl = _context.sent;
              // eslint-disable-next-line react/no-did-mount-set-state
              this.setState({
                hostName: window.location.hostname,
                chatUrl: chatUrl
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "componentWillReceiveProps",
    value: function () {
      var _componentWillReceiveProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nextProps) {
        var videoId, videoService, videoAppId, course, chatUrl;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.props.videoId !== nextProps.videoId)) {
                _context2.next = 6;
                break;
              }
              videoId = nextProps.videoId, videoService = nextProps.videoService, videoAppId = nextProps.videoAppId, course = nextProps.course;
              _context2.next = 4;
              return getStreamChatUrl(course.youtubeVideoUrl, {
                videoId: videoId,
                videoService: videoService,
                videoAppId: videoAppId
              }, this.context);
            case 4:
              chatUrl = _context2.sent;
              this.setState({
                chatUrl: chatUrl
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function componentWillReceiveProps(_x) {
        return _componentWillReceiveProps.apply(this, arguments);
      }
      return componentWillReceiveProps;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        hostName = _this$state.hostName,
        chatUrl = _this$state.chatUrl;
      var _this$props3 = this.props,
        lang = _this$props3.lang,
        course = _this$props3.course,
        isLiveStreamChatShown = _this$props3.isLiveStreamChatShown,
        formatMessage = _this$props3.intl.formatMessage,
        streamingNow = _this$props3.streamingNow,
        videoService = _this$props3.videoService,
        timeLeft = _this$props3.timeLeft,
        width = _this$props3.width;
      var _this$context = this.context,
        organizationSlug = _this$context.organizationSlug,
        whitelabeling = _this$context.whitelabeling;
      var youtubeVideoUrl = course.youtubeVideoUrl;
      if (timeLeft > 0) {
        var duration = moment.duration(timeLeft * 1000, 'milliseconds');
        var days = Math.floor(moment.duration(duration).asDays() || 0);
        var hours = moment.duration(duration).hours();
        var minutes = moment.duration(duration).minutes();
        var seconds = moment.duration(duration).seconds();
        hours = _.trim(hours).length === 1 ? "0".concat(hours) : hours;
        minutes = _.trim(minutes).length === 1 ? "0".concat(minutes) : minutes;
        seconds = _.trim(seconds).length === 1 ? "0".concat(seconds) : seconds;
        return /*#__PURE__*/_jsx("div", {
          className: s.root
        }, void 0, /*#__PURE__*/_jsx("div", {
          className: s.countdown
        }, void 0, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.livestreamStartsIn, {
          values: {
            minutes: minutes,
            hours: hours,
            seconds: seconds,
            days: days ? formatMessage(messages.days, {
              days: days
            }) : ''
          }
        }))));
      }
      var getVideoLoaderUrl = function getVideoLoaderUrl(whitelabeledOptions, pathTo, defaultLoader) {
        return _.get(whitelabeledOptions, "".concat(pathTo)) ? "".concat(_this2.context.cloudfrontUrl).concat(_.get(whitelabeling, "".concat(pathTo))) : defaultLoader;
      };
      var videoLoader = organizationSlug ? getVideoLoaderUrl(whitelabeling, 'videoLoader', "".concat(this.context.cloudfrontUrl, "/video-loader.png")) : "".concat(this.context.cloudfrontUrl, "/video-loader.png");
      var thumbnail = [{
        srcset: videoLoader,
        type: 'image/png'
      }];
      var videoJsOptions = {
        autoplay: !isIOS(),
        controls: true,
        speed: true,
        poster: thumbnail[0].srcset,
        thumbnail: thumbnail,
        // responsive: true,
        // fluid: true,
        language: lang,
        playsInline: isIOS(),
        controlBar: {
          children: ['playToggle', 'volumePanel', 'currentTimeDisplay', 'progressControl', 'qualitySelector', 'fullscreenToggle']
        }
      };
      if (videoService === 'youtube') {
        videoJsOptions.sources = [{
          type: 'video/youtube',
          src: youtubeVideoUrl
        }];
        videoJsOptions.youtube = {
          hl: lang
        };
      }
      if (videoService === 'vimeo') {
        videoJsOptions.sources = [{
          type: 'video/vimeo',
          src: youtubeVideoUrl
        }];
        videoJsOptions.vimeo = {
          playsinline: !isIOS()
        };
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, timeLeft <= 0 && isWidthDown('xs', width) && /*#__PURE__*/_jsx("div", {
        className: cx(s.mobileTitle)
      }, void 0, /*#__PURE__*/_jsx(Typography, {
        variant: "h1",
        className: s.title
      }, void 0, course.name), /*#__PURE__*/_jsx(LivestreamBadge, {
        timeLeft: timeLeft,
        course: course,
        streamingNow: streamingNow
      })), /*#__PURE__*/_jsx("div", {
        className: cx(s.root, s.available)
      }, void 0, /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/React.createElement(VideoPlayer, _extends({
        onReady: this.onVideoPlayerReady,
        onUnmount: this.onVideoPlayerUnmount
      }, videoJsOptions))), isLiveStreamChatShown && hostName && /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx("div", {
        className: s.chatWrapper
      }, void 0, /*#__PURE__*/_jsx("iframe", {
        width: "100%",
        height: "100%",
        src: "".concat(chatUrl).concat(videoService === 'youtube' ? "&embed_domain=".concat(hostName) : ''),
        frameBorder: "0",
        allow: "autoplay; encrypted-media",
        title: formatMessage(messages.livestreamChat),
        allowFullScreen: true
      })))));
    }
  }]);
  return CourseLivestream;
}(React.Component), _defineProperty(_class2, "defaultProps", {
  videoAppId: ''
}), _defineProperty(_class2, "contextType", AppContext), _class2)) || _class) || _class) || _class) || _class);
export { CourseLivestream as default };